export const site = {
  name: "Rigorfield",
  domain: "https://rigorfield.com",
  tagline: "Confidence Through Rigor.",
  altHeadline: "Know the Risks. Prove the Readiness.",
  category: "Digital Assurance, Security, Compliance and Launch Readiness",
  promise:
    "Independent, evidence-led assessments that help businesses identify risks, close critical gaps, and make better-informed decisions before launching or scaling digital products.",
  description:
    "Independent security, compliance, privacy and performance assessments that help businesses identify digital risks, address critical gaps, and launch with greater confidence.",
  email: "info@chandrabhansingh.in",
  phones: ["+91 7024315567", "+91 9755121478"],
  whatsapp: "917024315567",
  logo: "/brand/rigorfield-logo.png",
  mark: "/brand/rigorfield-mark.png",
  ogImage: "/brand/og-image.png",
  social: [],
  lastUpdated: "2026-10-25",
};

// Contact address (kept as published contact information).
export const office = {
  street: "Office No. 69, Ratan Colony, New Jail Road, Huzur",
  city: "Bhopal",
  region: "Madhya Pradesh",
  postalCode: "462038",
  country: "India",
  countryCode: "IN",
  get addressLine() {
    return `${this.street}, ${this.city}, ${this.region} ${this.postalCode}, ${this.country}`;
  },
};

// Business hours. Set `open24Hours` to false to hide the hours everywhere (UI + structured data).
export const hours = {
  open24Hours: true,
  label: "Open 24 hours, 7 days a week",
};

// Social-proof statistics. Figures are computed at runtime from the baseline below, so they
// grow automatically: clients and projects +1 per week, experience +1 year every calendar year.
// The average rating is intentionally NOT auto-incremented.
export const statsBaseline = {
  date: "2026-10-25", // baseline date (UTC)
  clients: 370,
  projects: 710,
  years: 9,
  yearsBaselineYear: 2026,
  rating: "4.9",
};

// CRM lead capture (used by every website form).
export const crm = {
  endpoint: "https://leadcrm.ashawebtechitsolutions.com/api/v1/leads",
  key: "lhk_e5627f33422f0cd60ce4ff736d07a291fae4ad35",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", menu: "services" },
  { label: "Industries", to: "/industries" },
  { label: "Compliance", to: "/compliance" },
  { label: "Pricing", to: "/pricing" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About Rigorfield", to: "/about", note: "Independent digital assurance" },
      { label: "Methodology", to: "/methodology", note: "How assessments are run" },
      { label: "How It Works", to: "/how-it-works", note: "From enquiry to report" },
      { label: "Customer Reviews", to: "/reviews", note: "What clients say about working with us" },
      { label: "Sample Report", to: "/sample-report", note: "Example assessment report" },
      { label: "FAQ", to: "/faq", note: "Common questions answered" },
      { label: "Partnerships", to: "/partnerships", note: "Enterprise and agency programmes" },
    ],
  },
  { label: "Contact", to: "/contact" },
];

export const footerLegal = [
  { label: "Privacy Policy", to: "/legal/privacy-policy" },
  { label: "Terms and Conditions", to: "/legal/terms-and-conditions" },
  { label: "Cookie Policy", to: "/legal/cookie-policy" },
  { label: "Disclaimer", to: "/legal/disclaimer" },
  { label: "Refund and Cancellation", to: "/legal/refund-and-cancellation-policy" },
  { label: "Acceptable Use", to: "/legal/acceptable-use-policy" },
  { label: "Security Disclosure", to: "/legal/security-disclosure-policy" },
  { label: "Vulnerability Disclosure", to: "/legal/responsible-vulnerability-disclosure" },
  { label: "Accessibility Statement", to: "/legal/accessibility-statement" },
  { label: "Data Retention", to: "/legal/data-retention-and-deletion-policy" },
  { label: "HTML Sitemap", to: "/sitemap" },
];

export const formOptions = {
  productTypes: ["Website", "Web application", "SaaS", "Mobile application", "E-commerce", "API", "AI product", "Other"],
  statuses: ["Planning", "Development", "Staging", "Already live"],
  countries: ["India", "European Union / EEA", "United Kingdom", "United States", "Canada", "Australia", "Singapore", "UAE", "Other"],
  enterpriseTypes: ["Enterprise assessments", "Multi-product assessments", "White-label agency audits", "Recurring assessment arrangements"],
  contactSubjects: ["General enquiry", "Service question", "Pricing question", "Partnership", "Security disclosure", "Other"],
};
